module.exports = __webpack_public_path__ + "img/avatar-1.4ddfcdce.png";